import { LicensesService } from "~/entity/Licenses/api/service";
import { ILicensesOverviewParams } from "~/entity/Licenses/model/schema";

export const useLicenses = () => {
  const queryKeys = {
    organizations: (params?: ILicensesOverviewParams) => [
      LicensesService._routes.licenses,
      "organizations",
      params,
    ],
    positionGroups: (params?: ILicensesOverviewParams) => [
      LicensesService._routes.licenses,
      "positionGroups",
      params,
    ],
    employees: (params?: ILicensesOverviewParams) => [
      LicensesService._routes.licenses,
      "employees",
      params,
    ],
  };

  const getLicensesOrganizations = LicensesService.GET.organizations;
  const getLicensesPositionGroups = LicensesService.GET.positionGroups;
  const getLicensesEmployees = LicensesService.GET.employees;

  return {
    queryKeys,
    getLicensesOrganizations,
    getLicensesPositionGroups,
    getLicensesEmployees,
  };
};
